import { useState } from 'react'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

export { PlanningHelp }

const PlanningHelp = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title="Tips voor de balkenplanning">
        <IconButton onClick={() => setOpen(true)}>
          <InfoOutlinedIcon />
        </IconButton>
      </Tooltip>

      <Dialog open={open}>
        <DialogTitle>Tips voor de planning</DialogTitle>

        <DialogContent>
          <DialogContentText>
            De balkenplanning is breder dan het scherm. Houd{' '}
            <Box component="code">Shift</Box> vast terwijl u met het muiswiel
            scrolt om horizontaal door de weken te scrollen.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)} autoFocus>
            Sluiten
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
